import { useEffect } from 'react';
import { useLayout } from '@cloud/shared';

import { cssVar, use100vh } from '@ovpn-ui/utils';
import { useSidebar } from '@ovpn-ui/navigation';
import {
    sidebarWidth,
    closedSidebarWidth,
} from '@ovpn-ui/navigation/Navigation/Navigation/Sidebar/Sidebar.constants';

/**
 * 100vh is not giving us real device height
 * in case of Android Chrome and Safari dynamic bar
 *  (both remove some usable height from 100vh).
 *
 * To not call use100vh everywhere, we can just put it value to css variable.
 */
export function useSetupCssVariables() {
    const deviceHeight = use100vh();

    const isOpen = useSidebar();
    const { isMobile, isTablet } = useLayout();

    const isSidebarVisible = isOpen && !isTablet;

    useEffect(() => {
        cssVar.set('--true-100vh', deviceHeight);
    }, [deviceHeight]);

    useEffect(() => {
        if (isMobile) {
            cssVar.set('--sidebar-left-offset', '0px');
        } else {
            cssVar.set(
                '--sidebar-left-offset',
                `${isSidebarVisible ? sidebarWidth : closedSidebarWidth}px`,
            );
        }
    }, [isSidebarVisible, isMobile]);
}
